import { Pipe, PipeTransform } from '@angular/core';
import { TaskState, TaskType } from '../../models/core';

@Pipe({
    name: 'taskskpicountPipe',
    standalone: false
})
export class KpicountPipePipe implements PipeTransform {

  transform(tasks:any, type:any ): number {
    const data = [...tasks.values()]
    switch(type) {
      case TaskType.Pickup: {
        return data.filter(x => x.task_type.toLowerCase() === TaskType.Pickup).length??0;
      }
      case TaskType.Break: {
        return data.filter(x => x.task_type.toLowerCase() === TaskType.Break).length??0;
      }
      case TaskType.Visit: {
        return data.filter(x => x.task_type.toLowerCase() === TaskType.Visit).length??0;
      }
      case TaskType.Deliver: {
        return data.filter(x => x.task_type.toLowerCase() === TaskType.Deliver).length??0;
      }
      case TaskType.Myboxpickup: {
        return data.filter(x => x.task_type.toLowerCase() === TaskType.Myboxpickup).length??0;
      }
      case TaskType.Emptymailbox: {
        return data.filter(x => x.task_type.toLowerCase() === TaskType.Emptymailbox).length??0;
      }
      case TaskState.Unplanned: {
        return data.filter(x => x.task_state.toLowerCase() === TaskState.Unplanned).length??0;
      }
      case TaskState.Rejected: {
        return data.filter(x => x.task_state.toLowerCase() === TaskState.Rejected).length??0;
      }
      case TaskState.Notacted: {
        return data.filter(x => x.task_state.toLowerCase() === TaskState.Notacted).length??0;
      }
      case TaskState.Cancelled: {
        return data.filter(x => x.task_state.toLowerCase() === TaskState.Cancelled).length??0;
      }
      default: {
        return 0;
      }
    }
  }

}
